import { createForm } from '../../../factories'

export default createForm(['title', 'description', 'file'])



// WEBPACK FOOTER //
// ./src/store/modules/bioreq/forms/store.js